import { render, staticRenderFns } from "./TicketHistoryTable.vue?vue&type=template&id=ee55e30c&scoped=true&"
import script from "./TicketHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TicketHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee55e30c",
  null
  
)

export default component.exports